import React, { useEffect, useState } from 'react';
import './planSummaryCard.scss';
import dedicatedIcon from '../../../../../../assests/dedicated-icon.png';
// import KnowMore from "../knowMore/knowMore";
import { capitalizeText, numberWithCommas, setInSessionStorage } from 'common/utils/app.utils';
import { getProductDisplayName, isNLD_OR_LL, isBulkUpgrade } from 'common/constants/app.constants';
import { MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED } from 'home/view/manage-feasibility/constants';

const PlanSummaryCard = ({ order: { lead, serviceType }, downloadSites = () => {} }) => {
  const { planDetail, lineItemCount } = lead;
  const [showKnowMoreClick, setShowKnowMoreClick] = useState(false);

  const onShowMoreClick = () => {
    setShowKnowMoreClick(!showKnowMoreClick);
  };

  const getServiceName = (serviceType) => {
    return getProductDisplayName(serviceType);
  };

  const getTotalSitesOrLinks = () => {
    if (isNLD_OR_LL()) {
      return Math.floor(lineItemCount / 2);
    }
    return lineItemCount;
  };

  useEffect(() => {
    // ;
    if (planDetail?.priceDto?.amount && planDetail?.priceDto?.amount > 0) {
      setInSessionStorage(MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED, true);
    }
  }, []);

  return (
    <React.Fragment>
      <div className="plan_summary_card aoi-card">
        <div className="plan_items">
          <div className="items-card">
            <div className="topcard-head">
              <img src={dedicatedIcon} className="icon-box" />
              <span className="title">{getServiceName(serviceType)}</span>
            </div>
            <div className="bottom-section">
              <div className="total-sites">
                {isNLD_OR_LL() ? 'Total Links' : 'Total Sites'}
                <span className="inner-value">{lineItemCount ? getTotalSitesOrLinks() : '-'}</span>
              </div>
              <div className="total-contract-value">
                <p style={{ marginBottom: '5px' }}>Total Contract Value</p>
                <span className={`inner-value inner-value-aoi ${planDetail?.priceDto?.discount ? 'strike_through' : ''}`}>
                  {' '}
                  &#8377; {planDetail?.priceDto?.amount ? numberWithCommas(planDetail?.priceDto?.amount) : '-'}{' '}
                </span>
                {planDetail?.priceDto?.discount !== 0 && planDetail?.priceDto?.discount && (
                  <span className="inner-value inner-value-aoi">&#8377; {`${numberWithCommas(planDetail?.priceDto?.amount - planDetail?.priceDto?.discount)}`} </span>
                )}
                {planDetail?.priceDto?.discount !== 0 && planDetail?.priceDto?.discount && (
                  <span className="inner-value inner-value-aoi discount">You Save &#8377; {`${planDetail?.priceDto?.discount}`} </span>
                )}
              </div>
            </div>

            {isBulkUpgrade() ? (
              <div className="more-link">
                <div className="upload_text">
                  <span onClick={downloadSites} class="link">
                    Download Sites
                  </span>
                </div>
              </div>
            ) : null}

            {/* <div className="installation-details">
              <div className="other-details">
                <div className="installation-info">
                  &#8377; {(planDetail && numberWithCommas(planDetail.priceDto.otc)) || '-'}
                  <span>Total Installation Fee (one-time charge)</span>
                </div>
                <div className="annual-charge">
                  &#8377; {planDetail && planDetail.totalPrice ? numberWithCommas(planDetail.totalPrice) : '-'}
                  <span>Total Annual Charge (ex. GST)</span>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PlanSummaryCard;
